import { combineReducers } from "@reduxjs/toolkit";
import { agroApi } from "shared/api/agroApi";
import { AUTH_SLICE_KEY, authSlice } from "features/auth/model/authSlice";
import { RootState } from "./root-state.interface";
import { CONFIG_SLICE_KEY, configReducer } from "./configSlice";

export const rootReducer = combineReducers<RootState>({
  [agroApi.reducerPath]: agroApi.reducer,
  [AUTH_SLICE_KEY]: authSlice.reducer,
  [CONFIG_SLICE_KEY]: configReducer,
});
